<template>
  <div class="row glovo-integration-form marketplace-settings">
    <div class="col-md-12">
      <section class="marketplace-action-panel marketplace-setup-panel">
        <div class="marketplace-action-heading"><i class="ti-location-pin" aria-hidden="true"></i><div><h6>{{ $t('marketplace.locations') }}</h6><p>{{ $t('marketplace.locationsSectionHint') }}</p></div></div>
        <div class="row">
    <div class="col-md-6">
      <div class="form-group" :class="{ 'has-error': showFieldError('location_id') }">
        <label for="glovo-location_id">{{ $t('marketplace.menuLocation') }}<span v-if="isRequired('location_id')" class="text-danger"> *</span></label>
        <select
          v-model="formData.location_id"
          id="glovo-location_id"
          class="form-control"
          :disabled="disabled"
        >
          <option :value="null">{{ $t('general.select') }}</option>
          <option
            v-for="loc in locations"
            :key="'glovo-loc-' + String(loc._integrationLocationId)"
            :value="loc._integrationLocationId"
          >
            {{ loc.name }}
          </option>
        </select>
        <p class="marketplace-field-hint">{{ $t('marketplace.menuHint') }}</p>
        <span v-if="showFieldError('location_id')" class="text-danger help-block">{{ fieldErrorMessage('location_id') }}</span>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group" :class="{ 'has-error': showFieldError('orders_location_id') }">
        <label for="glovo-orders_location_id">{{ $t('marketplace.ordersLocation') }}<span v-if="isRequired('orders_location_id')" class="text-danger"> *</span></label>
        <select
          v-model="formData.orders_location_id"
          id="glovo-orders_location_id"
          class="form-control"
          :disabled="disabled"
        >
          <option :value="null">{{ $t('general.select') }}</option>
          <option
            v-for="loc in locations"
            :key="'glovo-orders-loc-' + String(loc._integrationLocationId)"
            :value="locationOptionValue(loc)"
          >
            {{ loc.name }}
          </option>
        </select>
        <p class="marketplace-field-hint">{{ $t('marketplace.ordersHint') }}</p>
        <span v-if="showFieldError('orders_location_id')" class="text-danger help-block">{{ fieldErrorMessage('orders_location_id') }}</span>
      </div>
    </div>

        </div>
      </section>
      <section class="marketplace-action-panel marketplace-setup-panel">
        <div class="marketplace-action-heading"><i class="ti-key" aria-hidden="true"></i><div><h6>{{ $t('marketplace.credentials') }}</h6><p>{{ $t('marketplace.credentialsSectionHint') }}</p></div></div>
        <div class="row">
    <div class="col-md-6">
      <div class="form-group" :class="{ 'has-error': showFieldError('api_url') }">
        <label>{{ fieldLabel('api_url') }}<span v-if="isRequired('api_url')" class="text-danger"> *</span></label>
        <input
          type="text"
          class="form-control"
          v-model="formData.api_url"
          :disabled="disabled"
        >
        <span v-if="showFieldError('api_url')" class="text-danger help-block">{{ fieldErrorMessage('api_url') }}</span>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group" :class="{ 'has-error': showFieldError('pos_implementation_name') }">
        <label>{{ fieldLabel('pos_implementation_name') }}<span v-if="isRequired('pos_implementation_name')" class="text-danger"> *</span></label>
        <input
          type="text"
          class="form-control"
          v-model="formData.pos_implementation_name"
          :disabled="disabled"
        >
        <span v-if="showFieldError('pos_implementation_name')" class="text-danger help-block">{{ fieldErrorMessage('pos_implementation_name') }}</span>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group" :class="{ 'has-error': showFieldError('store_id') }">
        <label>{{ fieldLabel('store_id') }}<span v-if="isRequired('store_id')" class="text-danger"> *</span></label>
        <input
          type="text"
          class="form-control"
          v-model="formData.store_id"
          :disabled="disabled"
        >
        <span v-if="showFieldError('store_id')" class="text-danger help-block">{{ fieldErrorMessage('store_id') }}</span>
      </div>
    </div>


        </div>
      </section>
    </div>
  </div>
</template>

<script>
import {
  DEFAULT_GLOVO_LAAS_API_URL,
  DEFAULT_GLOVO_LAAS_POS_IMPLEMENTATION_NAME
} from 'src/components/Dashboard/Views/Integrations/GlovoLaasIntegrationForm.vue'
import { integrationLocationOptionValue } from 'src/components/Dashboard/Views/Integrations/integrationLocationHelpers.js'
import {
  getIntegrationFieldErrorMessage,
  hasIntegrationFieldError
} from 'src/components/Dashboard/Views/Integrations/integrationFormFieldHelpers.js'

export default {
  name: 'GlovoIntegrationForm',
  props: {
    formData: {
      type: Object,
      required: true
    },
    locations: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fieldLabelFn: {
      type: Function,
      default: null
    },
    requiredFields: {
      type: Array,
      default: () => []
    },
    validationErrors: {
      type: Object,
      default: () => ({})
    },
    showFieldValidation: {
      type: Boolean,
      default: false
    },
    topCategories: {
      type: Array,
      default: () => []
    }
  },
  created () {
    this.ensureDefaults()
  },
  methods: {
    fieldLabel (field) {
      if (typeof this.fieldLabelFn === 'function') return this.fieldLabelFn(field)
      return field
    },
    isRequired (field) {
      return (this.requiredFields || []).includes(field)
    },
    hasFieldError (field) {
      return Boolean(this.validationErrors && this.validationErrors[field])
    },
    showFieldError (field) {
      return hasIntegrationFieldError({
        field,
        validationErrors: this.validationErrors,
        showFieldValidation: this.showFieldValidation,
        requiredFields: this.requiredFields,
        formData: this.formData
      })
    },
    fieldErrorMessage (field) {
      return getIntegrationFieldErrorMessage({
        field,
        validationErrors: this.validationErrors,
        showFieldValidation: this.showFieldValidation,
        requiredFields: this.requiredFields,
        formData: this.formData,
        requiredMessage: this.$t('validations.requiredField')
      })
    },
    locationOptionValue (loc) {
      return integrationLocationOptionValue(loc)
    },
    ensureDefaults () {
      const url = this.formData.api_url
      if (url === undefined || url === null || String(url).trim() === '') {
        this.$set(this.formData, 'api_url', DEFAULT_GLOVO_LAAS_API_URL)
      }

      const posName = this.formData.pos_implementation_name
      if (posName === undefined || posName === null || String(posName).trim() === '') {
        this.$set(this.formData, 'pos_implementation_name', DEFAULT_GLOVO_LAAS_POS_IMPLEMENTATION_NAME)
      }
    }
  }
}
</script>

<style scoped>
.glovo-integration-form .has-error .form-control {
  border-color: #dc3545;
}
.glovo-integration-form .help-block {
  margin-top: 4px;
  margin-bottom: 0;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Integrations/GlovoIntegrationForm.vue